import React from 'react';
import useSWR from 'swr';
import { listReviews } from '../lib/api';
import { Skeleton } from '../components/ui/skeleton';

export default function Reviews() {
  const { data: reviews, isLoading } = useSWR('publicReviews', listReviews);

  return (
    <div className="min-h-screen bg-neutral-50 pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-serif text-neutral-900 mb-4">Customer Reviews</h1>
          <p className="text-neutral-600 max-w-2xl mx-auto">See what our customers have to say about their experience with Watch Studio.</p>
        </div>

        {isLoading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {Array.from({length: 8}).map((_, i) => (
              <Skeleton key={i} className="w-full aspect-[9/16] rounded" />
            ))}
          </div>
        ) : reviews?.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {reviews.map(review => (
              <div key={review.id} className="rounded border border-neutral-200 overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">
                <img src={review.image} alt="Customer Review" className="w-full h-auto object-cover" />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20 text-neutral-500">
            <p>No reviews available yet. Check back soon!</p>
          </div>
        )}
      </div>
    </div>
  );
}
